import React from 'react';
import { emptyCalculatorConfig } from '../../model/CalculatorConfig';
import { CalculatorSteps, createIntialCalculatorSteps } from '../../model/CalculatorSteps';



export interface CalculatorStepsStore {
    steps: CalculatorSteps;
    setSteps: (s: CalculatorSteps) => void;
}

const emptySteps: CalculatorSteps = createIntialCalculatorSteps(emptyCalculatorConfig);

const emptyStepsStore: CalculatorStepsStore = {
    steps: emptySteps,
    setSteps: (_steps: CalculatorSteps) => { return; }
}
export const CalculatorStepsContext = React.createContext<CalculatorStepsStore>(emptyStepsStore);
